type AnyAction<T = any> = {
    type: T;
    [extraProps: string]: any;
};

type AnyActionCreator = (...args: any[]) => AnyAction;

const routineStages = ['TRIGGER', 'REQUEST', 'SUCCESS', 'FAILURE', 'FULFILL'] as const;

type Routine = AnyActionCreator & {
    [key in (typeof routineStages)[number]]: string;
} & { [key in Lowercase<(typeof routineStages)[number]>]: AnyActionCreator };

function createAction(type: string): any {
    function actionCreator(...args: any[]) {
        return { type, payload: args[0] };
    }

    actionCreator.toString = () => `${type}`;
    actionCreator.type = type;

    return actionCreator;
}

const createRoutine = (typePrefix: string) => {
    const makeRoutineAction = (type: string) => createAction(`${typePrefix}/${type}`);

    const routine = routineStages.reduce((result, stage) => {
        const actionCreator = makeRoutineAction(stage);

        (result as any)[stage.toLowerCase()] = actionCreator;
        (result as any)[stage.toUpperCase()] = actionCreator.toString();
        return result;
    }, makeRoutineAction(routineStages[0]));

    return routine as unknown as Routine;
};

const createAuthRoutine = (name: string) => createRoutine(`@auth/${name}`);

export const authRoutines = {
    authorized: createAuthRoutine('AUTHORIZED'),
    unauthorized: createAuthRoutine('UNAUTHORIZED'),
    refreshToken: createAuthRoutine('REFRESH_TOKEN'),
    setAuthToken: createAuthRoutine('SET_AUTH_TOKEN'),
    getProductToken: createAuthRoutine('GET_PRODUCT_TOKEN'),
    login: createAuthRoutine('LOGIN'),
    logout: createAuthRoutine('LOGOUT'),
    getTenantAuth: createRoutine('GET_TENANT_AUTH'),
    editTenantAuth: createRoutine('EDIT_TENANT_AUTH'),
};
